import * as React from "react";

import { FormControl, TextareaAutosize } from "@mui/material";
import { Error, StyledTextArea } from "..";

interface IProps {
    label?: string;
    name?: string;
    value?: string | number;
    error?: any;
    onChange?: (value: any) => void;
    handleChange?: (value: any) => void;
    handleBlur?: (value: any) => void;
    touched?: any;
    placeholder?: string;
    rows?: number;
    isNumber?: boolean;
    onChangeEvent?: (event: React.ChangeEvent<HTMLTextAreaElement>) => void;
    disabled?: boolean;
}

export const AppTextArea = (props: IProps) => {
    const { label, value, error, name, placeholder, onChange, handleChange, handleBlur, touched, rows, isNumber, onChangeEvent, disabled = false } = props;

    const handleOnChange = React.useCallback(
        (event: any) => {
            // Kiểm tra nếu isNumber là true và giá trị nhập không phải là số thì không thực hiện handleChange
            if (isNumber && isNaN(Number(event.target.value))) {
                return;
            }
            handleChange && handleChange(event.target.value);
        },
        [handleChange, isNumber]
    );

    return (
        <StyledTextArea>
            <div className="input__wrapper">
                {label && <div className="input__label">{label}</div>}
                <FormControl sx={{ width: "100%" }} variant="outlined">
                    <TextareaAutosize
                        value={value}
                        onChange={(event) => {handleChange && handleOnChange(event); onChangeEvent && onChangeEvent(event);}}
                        onBlur={handleBlur}
                        name={name}
                        autoComplete="off"
                        placeholder={placeholder}
                        minRows={rows}
                        maxRows={8}
                        disabled={disabled}
                    />

                    {/* show error message only when change input value */}
                    {!!error && !!touched && <Error>{error}</Error>}
                    {/* show error message only when imply first submit action  */}
                    {/* {!!error || (name && <ErrorMessage name={name} component={Error} />)} */}
                </FormControl>
            </div>
        </StyledTextArea>
    );
};
